import { useContext } from "react";

import { AppContext } from "../../../../lib/appContext";

export const useTipsInput = (path?: string) => {
  const { businessUnitSlug, countryCode } = useContext(AppContext);
  return {
    businessUnitInput: {
      countryCode,
      slug: businessUnitSlug
    },
    desc: false,
    orderBy: "order",
    path
  };
};
